import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'primaria',
  emoji: '📘',
  title: 'PRIMARIA',
  description: '6 tomos Primaria + 6 bonos',
  originalPrice: '$72.990',
  price: '$19.990',
  ctaText: 'SÍ, QUIERO MEGAPACK PRIMARIA →',
  ctaHref: 'https://www.profepack.com/cart/48097228128512:1'
}, {
  id: 'completo',
  emoji: '🏆',
  title: 'PACK COMPLETO',
  description: 'Primaria + Secundaria + 6 bonos + Adaptaciones para el Aula Real',
  originalPrice: '$62.990',
  price: '$27.990',
  ctaText: 'SÍ, QUIERO PACK COMPLETO →',
  ctaHref: 'https://www.profepack.com/cart/48175123562752:1',
  isFeatured: true,
  savings: 'AHORRÁS $35.000'
}, {
  id: 'secundaria',
  emoji: '📗',
  title: 'SECUNDARIA',
  description: '6 tomos Secundaria + 6 bonos',
  originalPrice: '$72.990',
  price: '$19.990',
  ctaText: 'SÍ, QUIERO MEGAPACK SECUNDARIA →',
  ctaHref: 'https://www.profepack.com/cart/48175173173504:1'
}];
const subtitles: Record<string, string> = {
  primaria: 'El sistema completo de catequesis para nivel Primario',
  completo: 'La opción más elegida por docentes que enseñan en los dos niveles',
  secundaria: 'El sistema completo de catequesis para nivel Secundario'
};
export function PricingSection() {
  const [selected, setSelected] = useState('completo');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-206">
      <div className="max-w-xl mx-auto" data-id="element-207">
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-3" data-id="element-208">
          Elegí tu <span className="text-[#FFD700]" data-id="element-209">PROFEPACK:</span>
        </h2>
        <p className="text-gray-300 text-center text-xs sm:text-base mb-6 sm:mb-10" data-id="element-210">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>

        <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8" data-id="element-211">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-4 sm:p-5 transition-all ${isFeatured && isSelected ? 'border-2 border-[#FFD700] bg-[#0d0a00] shadow-[0_0_30px_rgba(255,215,0,0.15)]' : isFeatured ? 'border-2 border-[#FFD700]/50 bg-[#0d0a00]' : isSelected ? 'border-2 border-[#FFD700] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-212">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-213">
                  {/* Radio circle */}
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#FFD700]' : 'border-white/30'}`} data-id="element-214">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#FFD700]" data-id="element-215" />}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-216">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-217">
                      <span className="text-lg" data-id="element-218">{option.emoji}</span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-219">
                        {option.title}
                      </span>
                    </div>

                    {isFeatured && isSelected && <div className="flex items-center gap-2 mt-1.5 sm:mt-2 flex-wrap" data-id="element-220">
                        <span className="bg-[#FFD700] text-black text-[11px] sm:text-xs font-black px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full" data-id="element-221">
                          ⭐ MÁS ELEGIDO
                        </span>
                        {option.savings && <span className="bg-[#FFD700]/20 text-[#FFD700] text-[11px] sm:text-xs font-bold px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full border border-[#FFD700]/40" data-id="element-222">
                            {option.savings}
                          </span>}
                      </div>}

                    <p className="text-gray-400 text-sm mt-1" data-id="element-223">
                      {option.description}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-224">
                    <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-225">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#FFD700]' : 'text-white'}`} data-id="element-226">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Single CTA */}
        <a href={selectedOption.ctaHref} className="btn-green-pulse block w-full text-center bg-[#FFD700] text-black font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl sm:rounded-2xl hover:bg-[#FFE44D] transition-colors" data-id="element-227">
          {selectedOption.ctaText}
        </a>

        <p className="text-gray-400 text-xs sm:text-sm text-center mt-3 sm:mt-4 italic" data-id="element-228">
          {subtitles[selected]}
        </p>

        {/* Trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-300 mt-6 sm:mt-8 bg-[#0a0a0a] border border-[#FFD700]/20 rounded-xl py-3 sm:py-4 px-4 sm:px-6" data-id="element-229">
          <span data-id="element-230">🔒 Pago seguro</span>
          <span data-id="element-231">⚡ Acceso en 5 min</span>
          <span data-id="element-232">🛡️ Garantía 7 días</span>
          <span data-id="element-233">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}